"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtsyMarkWhiteIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** ArtsyMarkWhiteIcon */
var ArtsyMarkWhiteIcon = function ArtsyMarkWhiteIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Artsy" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.G, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: "#F8F8F8",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M0 31.963h31.876V.09H0v31.874zm29.583-2.293h-4.824v-6.283h-2.295v6.283H2.294V2.382h27.289V29.67z",
    fill: "#FFF"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M12.854 5.677h-2.53L5.64 17.737h2.422l1.265-3.382h4.541l1.247 3.382h2.424l-4.685-12.06zm-2.82 6.636l1.555-4.197 1.537 4.197h-3.093z",
    fill: "#FFF"
  })));
};

exports.ArtsyMarkWhiteIcon = ArtsyMarkWhiteIcon;
ArtsyMarkWhiteIcon.displayName = "ArtsyMarkWhiteIcon";
//# sourceMappingURL=ArtsyMarkWhiteIcon.js.map